const YOUTUBE_VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

function validVideoId(candidate: string | null | undefined): string | null {
  return candidate && YOUTUBE_VIDEO_ID_PATTERN.test(candidate) ? candidate : null;
}

export function isYouTubeHostname(hostname: string): boolean {
  const normalizedHostname = hostname.toLowerCase();
  return (
    normalizedHostname === "youtu.be" ||
    normalizedHostname.endsWith(".youtu.be") ||
    normalizedHostname === "youtube.com" ||
    normalizedHostname.endsWith(".youtube.com") ||
    normalizedHostname === "youtube-nocookie.com" ||
    normalizedHostname.endsWith(".youtube-nocookie.com")
  );
}

export function getYoutubeVideoId(rawUrl: string): string | null {
  if (!rawUrl?.trim()) return null;

  let parsedUrl: URL;
  try {
    const trimmedUrl = rawUrl.trim();
    parsedUrl = new URL(/^[a-z][a-z\d+.-]*:\/\//i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`);
  } catch {
    return null;
  }

  const hostname = parsedUrl.hostname.toLowerCase();
  if (hostname === "youtu.be" || hostname.endsWith(".youtu.be")) {
    return validVideoId(parsedUrl.pathname.split("/").filter(Boolean)[0]);
  }

  if (isYouTubeHostname(hostname)) {
    const watchVideoId = validVideoId(parsedUrl.searchParams.get("v"));
    if (watchVideoId) return watchVideoId;

    const pathSegments = parsedUrl.pathname.split("/").filter(Boolean);
    if (["live", "shorts", "embed", "v"].includes(pathSegments[0])) {
      return validVideoId(pathSegments[1]);
    }
    return null;
  }

  const isGoogleHost = hostname === "google.com" || hostname.endsWith(".google.com");
  if (isGoogleHost) {
    const hashParams = new URLSearchParams(parsedUrl.hash.replace(/^#/, ""));
    const googleVideoDescriptor = hashParams.get("vld");
    const googleVideoId = googleVideoDescriptor?.match(/(?:^|,)vid:([A-Za-z0-9_-]{11})(?:,|$)/)?.[1];
    return validVideoId(googleVideoId);
  }

  return null;
}
